import { NavBar } from "./components/NavBar";
import { useEffect } from "react";
import React from "react";
import ReactPlayer from "react-player/youtube";
import Footer from "./components/Footer";
import InfoCard from "./components/InfoCard";
// import SidePopUp from "./components/SidePopUp";
// import ButtonShadow from "./components/ButtonShadow";
import TrustPilot from "./components/TrustPilot";
import { initializeEmailButton } from "./helpers/emailButtonHelper";

// import { AppContext } from './AppContext';

function Home() {
  useEffect(() => {
    initializeEmailButton();
  }, []);

  return (
    <div className="App">
      <div className="pageWrapper">
        <NavBar />
      </div>

      <div className="topSection">
  
          <div className="topContent">
            <div className="questionsFormat2Content">
              <p>Sign-ups for new diesel emissions claims are <span className="text-bold">now closed</span>.</p>
            </div>
       
          </div>
   
      </div>
      <div className="middleSction"></div>
      <div className="bottomSection">
        <div className="infoCardsSectionWrapper">
          <div className="infoCardsWrapper introCopyWrapper">
            <div className="infoSection">
              <div className="infoSectionItem">
                <div className="infocardTitle">What is My Diesel Claim?</div>
                <p>
                  My Diesel Claim investigates diesel emissions fraud by car manufacturers between 2009 and 2020, aiming to compensate drivers of affected vehicles.
                </p>
                <InfoCard copy="Volkswagen settled for £193M in May 2022 due to their involvement in the emissions scandal, setting a precedent for future cases." />

                <p>
                  Numerous car brands, including Mercedes, VW, Audi, BMW, and others, are implicated in the scandal, with some already paying substantial
                  compensation. Pogust Goodhead emphasises the importance of holding corporations accountable for environmental damage.
                </p>
              </div>
              <div className="infoSectionItem">
                <p className="infocardTitle">What are cheat devices?</p>
                <p>
                  Defeat devices, also commonly called cheat devices, are fitted into diesel vehicles to falsify emissions levels by using test conditions to
                  pass regulatory checks.
                </p>
                <p>
                  Real-world driving conditions produce much higher emissions levels, meaning affected vehicles would not pass regulatory checks without the use
                  of defeat devices.
                </p>
                <p>Emissions laws are therefore being cheated and excess emissions can have consequences for the environment and the health of the public.</p>
                <InfoCard copy="You can read more about the diesel emissions fraud claim on the Money Saving Expert (MSE) website." />
              </div>
            </div>
            <div className="infoSectionBottom">
              <p className="youTubeHeading">My Diesel Claim Webinar</p>
              <div className="youTubeWrapper">
                <div className="youTubeConatiner infoSectionItem">
                  <ReactPlayer className="reactPlayer" url="https://youtu.be/FKr56qf-5iU" width={"100%"} height={"100%"} controls={true} />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <TrustPilot />
        </div>

        <Footer />
      </div>
      {/* <Questions vehicleData={vehicleData} index={index} setIndex={setIndex} setRegPlate={setRegPlate} regPlate={regPlate} answers={answers} setAnswers={setAnswers} setJourney={setJourney} journey={journey} /> */}
    </div>
  );
}

export default Home;
